import generateCRUDOps from './utils/generateCrud';

const pathPrefix = `/settings/`;

const SettingsService = {
  // Use actual CRUD operations
  ...generateCRUDOps(pathPrefix, 'access-keys'),
};

export default SettingsService;
